import { createElement, forwardRef, useImperativeHandle, useState } from 'react';
import { BaseHelpPopup } from '../../../HelpPopup/__internal__';
import { IconHelpPopupProps, IconHelpPopupAPIRef } from '.';

/**
 * The IconHelpPopup used in ListColumnProps.
 */
export const IconHelpPopup = forwardRef<IconHelpPopupAPIRef, IconHelpPopupProps>(
  function IconHelpPopup(props, ref) {
    const [isOpen, setIsOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      toggle: () => setIsOpen(!isOpen),
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
    }));

    return <BaseHelpPopup {...props} isOpen={isOpen} setIsOpen={setIsOpen} focusable={false} />;
  }
);
